import { Component } from "@angular/core";
import { tap } from "rxjs";
import { slideUpOnEnter } from "source/app/animations";
import { DispatchUndoService } from "source/app/configuration/services/dispatch-undo.service";

const DISMISS_DISTANCE_PX = 56;

@Component({
	selector: "app-dispatch-undo-toast",
	templateUrl: "./dispatch-undo-toast.component.html",
	styleUrls: ["./dispatch-undo-toast.component.scss"],
	animations: [slideUpOnEnter],
})
export class DispatchUndoToastComponent {
	constructor(private dispatchUndo: DispatchUndoService) {}

	dragY = 0;
	dragging = false;
	settling = false;

	private startY = 0;

	toast$ = this.dispatchUndo.toast$.pipe(
		tap(() => {
			this.dragY = 0;
			this.dragging = false;
			this.settling = false;
		}),
	);

	get dragActive(): boolean {
		return this.dragging || this.settling || this.dragY > 0;
	}

	get dragOpacity(): number {
		return 1 - Math.min(this.dragY / 120, 0.85);
	}

	cancel = () => this.dispatchUndo.undo();

	onPointerDown = (event: PointerEvent) => {
		if ((event.target as HTMLElement).closest("button")) {
			return;
		}
		this.settling = false;
		this.dragging = true;
		this.startY = event.clientY - this.dragY;
		(event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
	};

	onPointerMove = (event: PointerEvent) => {
		if (!this.dragging) {
			return;
		}
		this.dragY = Math.max(0, event.clientY - this.startY);
	};

	onPointerUp = () => {
		if (!this.dragging) {
			return;
		}
		this.dragging = false;
		if (this.dragY >= DISMISS_DISTANCE_PX) {
			this.dispatchUndo.commitHeld();
			return;
		}
		if (this.dragY === 0) {
			return;
		}
		this.settling = true;
		this.dragY = 0;
	};

	onSettleEnd = () => {
		if (!this.settling) {
			return;
		}
		this.settling = false;
	};
}
